import { useSelector } from "react-redux"
import { type RootState } from "~Shared/store/rootState.interface"

export const useImportInProgress = () => useSelector(({ imports }: RootState) => imports.isInProgress)
export const useImportResultId = () => useSelector(({ imports }: RootState) => imports.importResultId)
export const useDataUploadNotification = () => useSelector(({ imports }: RootState) => imports.notification)
